/**
 * Buduje liste numerow stron z wielokropkami, np. `1 … 4 5 6 … 20`.
 *
 * W osobnym pliku, zeby `Pagination.tsx` eksportowal wylacznie komponent —
 * tego wymaga poprawne dzialanie fast refresh.
 */
export function buildPageRange(page: number, pageCount: number, siblings = 1): (number | '…')[] {
  if (pageCount <= 1) return [1];

  const pages = new Set<number>([1, pageCount]);
  for (let offset = -siblings; offset <= siblings; offset += 1) {
    const candidate = page + offset;
    if (candidate >= 1 && candidate <= pageCount) pages.add(candidate);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result: (number | '…')[] = [];

  sorted.forEach((value, index) => {
    const previous = sorted[index - 1];
    if (previous !== undefined && value - previous > 1) result.push('…');
    result.push(value);
  });

  return result;
}
